/**
 * Helper functions for status message handling in chat components
 */

export const getStatusEmoji = (status: string): string => {
  const statusMap: Record<string, string> = {
    initializing: '⏳',
    queued: '⏳',
    progress: '🕐', ///⚙️🧭⏱️🕐🔍✍️📝
    processing: '⏳',
    requires_action: '🤔',
    completed: '✅',
    failed: '❌',
    cancelled: '🚫',
    incomplete: '⚠️',
    tool: '⚙️',
    preparing: '✍️',
    filtered: '🔒',
    timeout: '⏰',
    streaming: '✍️',
    analyzing: '🔍',
    crisis: '🚨'
  };
  
  // Check if any status keyword is a substring of the statusMessage
  for (const [keyword, emoji] of Object.entries(statusMap)) {
    if (status.toLowerCase().includes(keyword.toLowerCase())) {
      return emoji;
    }
  }
  
  return '⏱️';
};

export const getStatusTooltip = (status: string): string => {
  return status;
};
